import { PseudoPostType } from 'constants/post';
import { AttachmentsHandlerFunction } from './types';

export const processVideoAttachments =
  ({
    acceptedPseudoTypes = [PseudoPostType.Reel],
  }: {
    acceptedPseudoTypes?: PseudoPostType[];
  }) =>
  ({
    form,
    pseudoPost,
    attachmentsByPseudoType,
  }: AttachmentsHandlerFunction) => {
    const selectedPseudoPost = PseudoPostType.Video;

    if (form.pseudoType === selectedPseudoPost) {
      const hasUploadedVideo = form.attachments?.cards?.length > 0;
      if (hasUploadedVideo) {
        return form.attachments?.cards ?? [];
      }
    }

    if (acceptedPseudoTypes.includes(form.pseudoType)) {
      return form.attachments?.cards ?? [];
    }

    return attachmentsByPseudoType[pseudoPost.key]?.cards ?? [];
  };
